export default __webpack_public_path__ + "static/media/platform-assets.bb452d25.png";